<template>
  <div
    :style="`height: ${escala ? 70 * escala : 70}px; width: ${escala ? 70 * escala : 70}px;`"
    class="loading-circulo-container"
  >
    <div class="loading-posicionamento">
      <div
        :style="{ scale: escala ? `${escala}` : '' }"
        :class="['circulo-base', `${classe}-circle`]"
      >
        <div
          :class="[
            'circulo-interno-wrapper',
            grow ? 'circulo-interno-animacao-1' : 'circulo-interno-animacao-2'
          ]"
        >
          <div class="circulo-interno"></div>
        </div>
        <div :class="['svg-circle', grow ? 'animation-grow' : 'animation-shrink']">
          <svg>
            <circle class="circulo1" transform="translate(2, 2)" cx="30" cy="30" r="30"></circle>
            <!-- <circle class="circulo2" transform="translate(5, 5)" cx="27" cy="27" r="27"></circle> -->
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Circulo",
  props: {
    escala: String,
    classe: String
  },
  data() {
    return {
      grow: true
    };
  },
  mounted() {
    this.trocaAnimacao();
  },
  methods: {
    trocaAnimacao() {
      setTimeout(() => {
        this.grow = !this.grow;
        this.trocaAnimacao();
      }, 1500);
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes loadingRotate1 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes loadingRotate2 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes strokeGrow {
  0% {
    stroke-dashoffset: 190;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes strokeShrink {
  0% {
    scale: -1 1;
    translate: -1px 0px;
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 190;
    scale: -1 1;
    translate: -1px 0px;
  }
}
.loading-circulo-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-posicionamento {
  position: absolute;
}
.circulo-base {
  position: relative;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 11px solid #ffffff20;
  // filter: brightness(0.5);
  // box-shadow: 0 0 0 2px rgba(24, 102, 0, 0.493);
  // z-index: 100;
  // transform: translateZ(0px);
}
.circulo-interno-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  // background: red;
  z-index: 100;
}
.circulo-interno-animacao-1 {
  animation: loadingRotate1 1.5s infinite ease-in-out;
}
.circulo-interno-animacao-2 {
  animation: loadingRotate2 1.5s infinite ease-in-out;
}
.circulo-interno {
  position: absolute;
  top: -11px;
  border-radius: 50%;
  width: 11px;
  height: 11px;
  background: var(--cinza02);
  z-index: 100;
}
.svg-circle {
  position: absolute;
  top: -10px;
  left: -8px;
  svg {
    width: 65px;
    height: 65px;
    fill: transparent;
    stroke-width: 4;
    stroke: var(--cinza02);
    stroke-dasharray: 190;
    stroke-dashoffset: 0;
    transform-origin: center;
    transform-box: border-box;
    transform: rotate(-90deg);
  }
}
.animation-grow {
  svg {
    animation: strokeGrow 1.5s infinite ease-in-out;
  }
}
.animation-shrink {
  svg {
    animation: strokeShrink 1.5s infinite ease-in-out;
  }
}
.preferencia_tarifaria-circle,
.class_importacao-circle {
  border: 11px solid #ffffff42;
  .circulo-interno {
    background: var(--importacao);
  }
  .svg-circle {
    svg {
      stroke: var(--importacao);
    }
  }
}

.pis_cofins-circle,
.cide_combustivel-circle {
  border: 11px solid #ffffff42;
  .circulo-interno {
    background: var(--pis-cofins);
  }
  .svg-circle {
    svg {
      stroke: var(--pis-cofins);
    }
  }
}

.icms_interno-circle,
.icms_st-circle,
.carga_liquida-circle,
.antecipacao-circle,
.difal-circle {
  border: 11px solid #ffffff42;
  .circulo-interno {
    background: var(--icms);
  }
  .svg-circle {
    svg {
      stroke: var(--icms);
    }
  }
}

.ipi-circle {
  border: 11px solid #ffffff42;
  .circulo-interno {
    background: var(--ipi);
  }
  .svg-circle {
    svg {
      stroke: var(--ipi);
    }
  }
}
.verde-circle {
  border: 11px solid #ffffff20;
  .circulo-interno {
    background: var(--verde2);
  }
  .svg-circle {
    svg {
      stroke: var(--verde2);
    }
  }
}
.azul-circle {
  border: 11px solid #ffffff20;
  .circulo-interno {
    background: var(--azul2);
  }
  .svg-circle {
    svg {
      stroke: var(--azul2);
    }
  }
}
</style>
